/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Govern_Ai_UseInputs */



/**
* | output |
* | --- |
* | "Govern AI use across the company" |
*
* @param {Onboarding_Usage_Govern_Ai_UseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_govern_ai_use = /** @type {((inputs?: Onboarding_Usage_Govern_Ai_UseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Govern_Ai_UseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Nutzung im Unternehmen steuern")
	return /** @type {LocalizedString} */ ("Govern AI use across the company")
});